module.exports = "<div class=\"layout__scope content--new-nav\" ng-class=\"{'layout__scope--no-touch': $ctrl.noTouch}\"> <ng-transclude></ng-transclude> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/pageContent/pageContent.html
// module id = 1462
// module chunks = 28